import type {
  ManualCampaignForm,
  SelectedScreenMeta,
} from '@/features/campaigns/types/campaign';

export type ScreensStepProps = {
  campaignData: ManualCampaignForm;
  selectedIds: string[];
  selectedMeta: Record<string, SelectedScreenMeta>;
  onSelect: (screen: Record<string, unknown>) => void;
  error?: string;
};

export type ScreenFilters = {
  locationType: string[];
  venueType: string[];
  venueSubType: string[];
};

export type ScreenOrientationFilter =
  | 'MATCHING'
  | 'ALL'
  | 'PORTRAIT'
  | 'LANDSCAPE'
  | 'SQUARE';

/** Client-side inventory sort (catalog / page results). */
export type ScreenSortMode = 'recommended' | 'price_asc' | 'price_desc';

export type ScreenListItem = {
  _id?: string;
  id?: string;
  screenName?: string;
  name?: string;
  thumbnail?: { url?: string };
  address?: {
    building?: string;
    area?: string;
    locality?: string;
    street?: string;
    fullAddress?: string;
    secondaryAddress?: string;
    district?: string;
    city?: string;
    state?: string;
  };
  basePrice?: number;
  screenOrientation?: string;
  screenType?: string;
};

export const EMPTY_SCREEN_FILTERS: ScreenFilters = {
  locationType: [],
  venueType: [],
  venueSubType: [],
};
